module.exports = __webpack_public_path__ + "static/valor-digital-solutions-sydney-37cbf448f54c2dbb5bca6968861e59ba.jpg";